__webpack_require__.p = "https://bmidxbromaniaplprod.netlify.app/";